import { useQuery } from 'react-query';

import workspaceService from '@app/libs/workspaceService';
import {
  DocumentDetail,
  getDocumentsByIdDeprecated,
} from '@app/store/transport-layer/document/documents';

export default function useDocument<T>({
  refetchOnWindowFocus = true,
  documentId,
  select,
  staleTime,
}: {
  refetchOnWindowFocus?: boolean;
  staleTime?: number;
  documentId: string;
  select?: (document: DocumentDetail) => T;
}) {
  return useQuery<DocumentDetail, Error, T>({
    refetchOnWindowFocus,
    staleTime,
    queryKey: `document-${documentId}`,
    queryFn: () =>
      getDocumentsByIdDeprecated({
        workspaceId: workspaceService.getWorkspaceId(),
        documentId,
      }),
    select,
    enabled: workspaceService.hasWorkspaceId(),
  });
}
